import { PointsScreen } from "@/src/screens/points-screen";

export default function PointsRoute() {
  return <PointsScreen />;
}
